@if (loading()) {
<app-page-loader loadingType="content" />
} @else {
<div class="p-3 h-[calc(100%-var(--spacing)*15)]">
  <app-breadcrumb [items]="[{ label: 'Translations', route: '/translations' },{ label: 'Import' }]"/>
  <div class="h-[calc(100%-var(--spacing)*9)] rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
    <div class="h-full w-full overflow-y-scroll">

      @if (canEdit()) {
      <!-- File Import Toolbar -->
      <div class="sticky flex flex-wrap items-end gap-4 top-0 left-0 bg-white border-b border-stroke px-5 py-4 dark:border-strokedark sm:px-7.5">

        <!-- Upload type -->
        <div>
          <label class="block text-xs text-gray-500 dark:text-gray-400 mb-2">Upload Type</label>
          <div class="flex gap-4">
            <label class="flex items-center gap-1.5 cursor-pointer text-sm text-gray-700 dark:text-gray-300">
              <input type="radio" [(ngModel)]="selectedUploadType" value="SurveyTranslations" class="accent-blue-600"/>
              Survey Translations
            </label>
            <label class="flex items-center gap-1.5 cursor-pointer text-sm text-gray-700 dark:text-gray-300">
              <input type="radio" [(ngModel)]="selectedUploadType" value="GlobalTranslations" class="accent-blue-600"/>
              Global Translations
            </label>
          </div>
        </div>

        <!-- File input -->
        <div class="flex-1">
          <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Files (CSV / Excel)</label>
          <input type="file" multiple accept=".csv,.xlsx,.xls" (change)="onFileChange($event)" class="block text-sm text-gray-700 file:mr-3 file:rounded-lg file:border-0 file:bg-blue-50 file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-blue-700 hover:file:bg-blue-100 dark:text-gray-300 dark:file:bg-gray-800 dark:file:text-gray-300"/>
        </div>

        <!-- Import button -->
        <button type="button" (click)="requestImport()"
          [disabled]="!canImport"
          class="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
          @if (requesting()) {
            <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
            Importing...
          } @else {
            Import
          }
        </button>
      </div>

      <!-- Selected files list -->
      @if (selectedFiles.length > 0) {
      <div class="px-5 pt-3 flex flex-wrap gap-2">
        @for (file of selectedFiles; track file.name; let i = $index) {
        <span class="flex items-center gap-1.5 rounded-full bg-gray-100 px-3 py-1 text-xs text-gray-700 dark:bg-gray-800 dark:text-gray-300">
          {{ file.name }}
          <button type="button" (click)="removeFile(i)" class="ml-1 text-gray-400 hover:text-red-500">&times;</button>
        </span>
        }
      </div>
      }
      }

      <!-- Errors -->
      @if (fileError()) {
      <div class="px-5 pt-3">
        <p class="rounded-lg border border-red-200 p-3 text-sm text-red-600 bg-red-100">{{ fileError() }}</p>
      </div>
      }
      @if (importApiError()) {
      <div class="px-5 pt-3">
        <div class="rounded-lg border border-red-200 bg-red-50 p-3 text-sm dark:border-red-800 dark:bg-red-950">
          <div class="flex items-center gap-2 mb-1">
            <span class="rounded px-1.5 py-0.5 text-xs font-bold bg-red-200 text-red-800 dark:bg-red-800 dark:text-red-200">{{ importApiError()!.code }}</span>
            <span class="font-medium text-red-700 dark:text-red-300">{{ importApiError()!.description }}</span>
          </div>
          @if (importApiError()!.details.length > 0) {
          <pre class="mt-1 whitespace-pre-wrap text-xs text-red-600 dark:text-red-400">{{ importApiError()!.details | json }}</pre>
          }
        </div>
      </div>
      }
      @if (error()) {
      <div class="px-5 pt-3">
        <p class="rounded-lg border border-red-200 p-3 text-sm text-red-600 bg-red-100">{{ error() }}</p>
      </div>
      }

      <!-- History table -->
      <div class="p-5">
        <div class="flex flex-wrap items-center justify-between gap-3 mb-3">
          <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-200">Import History</h3>
          <div class="flex flex-wrap items-center gap-2">
            <label class="text-xs text-gray-500 dark:text-gray-400">Type</label>
            <select [(ngModel)]="historyFilterType" (change)="onHistoryFilterChange()" class="h-8 rounded-lg border border-gray-300 bg-white px-2 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white">
              <option value="">All</option>
              <option value="SurveyTranslations">Survey</option>
              <option value="GlobalTranslations">Global</option>
            </select>
            <label class="text-xs text-gray-500 dark:text-gray-400">Per page</label>
            <select [(ngModel)]="historyPerPage" (change)="onPerPageChange()" class="h-8 rounded-lg border border-gray-300 bg-white px-2 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white">
              @for (opt of perPageOptions; track opt) {
                <option [ngValue]="opt">{{ opt }}</option>
              }
            </select>
            <button type="button" (click)="loadAllHistory()" [disabled]="loadingHistory()" title="Refresh" class="flex items-center justify-center h-8 w-8 rounded-lg border border-gray-300 bg-white text-gray-500 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:bg-gray-900 dark:hover:bg-gray-800">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" [class.animate-spin]="loadingHistory()" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
              </svg>
            </button>
          </div>
        </div>

        @if (loadingHistory()) {
          <div class="flex justify-center py-10">
            <svg class="h-6 w-6 animate-spin text-blue-500" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
          </div>
        } @else if (historyItems().length === 0) {
          <p class="py-10 text-center text-sm text-gray-400">No import history found.</p>
        } @else {
          <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
            <table class="w-full text-sm text-left text-gray-700 dark:text-gray-300">
              <thead class="bg-gray-50 text-xs text-gray-500 uppercase dark:bg-gray-800 dark:text-gray-400">
                <tr>
                  <th class="pl-5 pr-4 py-3">Import ID</th>
                  <th class="px-4 py-3">Type</th>
                  <th class="px-4 py-3">Format</th>
                  <th class="px-4 py-3">Status</th>
                  <th class="px-4 py-3">Results</th>
                  <th class="px-4 py-3">Download</th>
                  <th class="px-4 py-3">Created</th>
                  <th class="px-4 py-3">Updated</th>
                </tr>
              </thead>
              <tbody>
                @for (item of historyItems(); track item.id) {
                <tr class="border-t border-gray-100 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-800" [title]="item.errorDescription ?? ''">
                  <td class="pl-5 pr-4 py-3 max-w-24">
                    <button type="button" (click)="copyToClipboard(item.id)"
                      class="group relative font-mono text-xs text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
                      [title]="item.id">
                      @if (copiedText() === item.id) {
                        <span class="flex items-center gap-1.5 text-green-500">
                          <svg class="h-3.5 w-3.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                          Copied!
                        </span>
                      } @else {
                        <svg class="absolute -left-4 top-1/2 -translate-y-1/2 h-3.5 w-3.5 opacity-0 group-hover:opacity-100 transition-opacity" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                        </svg>
                        <span class="inline-block max-w-24 truncate">{{ item.id }}</span>
                      }
                    </button>
                  </td>
                  <td class="px-4 py-3">
                    <span class="rounded px-2 py-0.5 text-xs font-medium"
                      [class.bg-purple-100]="item.importType === 'SurveyTranslations'"
                      [class.text-purple-700]="item.importType === 'SurveyTranslations'"
                      [class.bg-indigo-100]="item.importType === 'GlobalTranslations'"
                      [class.text-indigo-700]="item.importType === 'GlobalTranslations'">
                      {{ item.importType === 'SurveyTranslations' ? 'Survey' : 'Global' }}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <span class="rounded px-2 py-0.5 text-xs font-medium"
                      [class.bg-blue-100]="item.format === 'CSV'"
                      [class.text-blue-700]="item.format === 'CSV'"
                      [class.bg-green-100]="item.format === 'Excel'"
                      [class.text-green-700]="item.format === 'Excel'">
                      {{ item.format }}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <span class="rounded px-2 py-0.5 text-xs font-medium"
                      [class.bg-gray-100]="item.status === 'created'"
                      [class.text-gray-600]="item.status === 'created'"
                      [class.bg-green-100]="item.status === 'completed'"
                      [class.text-green-700]="item.status === 'completed'"
                      [class.bg-red-100]="item.status === 'error'"
                      [class.text-red-700]="item.status === 'error'">
                      {{ item.status }}
                    </span>
                  </td>
                  <td class="px-4 py-3 text-xs text-gray-500 whitespace-nowrap max-w-24">
                  @if (item.status === 'completed') {
                    <div class="flex flex-col gap-0.5">
                      <span>Total: <span class="font-medium text-gray-700">{{ item.totalItems }}</span></span>
                      <span>Skipped: <span class="font-medium text-gray-700">{{ item.skipRows }}</span></span>
                      <span class="text-green-600">New: <span class="font-medium">{{ item.newTranslation }}</span></span>
                      <span class="text-blue-600">Updated: <span class="font-medium">{{ item.updateTranslations }}</span></span>
                    </div>
                  } @else if (item.status === 'error') {
                    <button type="button" (click)="copyToClipboard(item.errorDescription ?? '')"
                      class="group relative font-mono text-xs text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
                      [title]="item.errorDescription">
                      @if (copiedText() === item.errorDescription) {
                        <span class="flex items-center gap-1.5 text-green-500">
                          <svg class="h-3.5 w-3.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                          Copied!
                        </span>
                      } @else {
                        <svg class="absolute -left-4 top-1/2 -translate-y-1/2 h-3.5 w-3.5 opacity-0 group-hover:opacity-100 transition-opacity" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                        </svg>
                        <span class="inline-block max-w-24 truncate">{{ item.errorDescription }}</span>
                      }
                    </button>
                  } @else {
                    —
                  }
                  </td>
                  <td class="px-4 py-3 text-xs">
                  @if (item.downloadUrl) {
                    <a [href]="item.downloadUrl" target="_blank" class="text-blue-600 hover:underline text-xs font-medium">
                      Download
                    </a>
                  } @else {
                    <span class="text-gray-300 text-xs">—</span>
                  }
                  </td>
                  <td class="px-4 py-3 text-xs">{{ item.createdDate | date:'yyyy-MM-dd HH:mm' }}</td>
                  <td class="px-4 py-3 text-xs">{{ item.updatedDate ? (item.updatedDate | date:'yyyy-MM-dd HH:mm') : '—' }}</td>
                </tr>
                }
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="mt-4 flex items-center justify-between text-sm text-gray-600 dark:text-gray-400">
            <span>{{ totalCount() }} result{{ totalCount() === 1 ? '' : 's' }} &mdash; page {{ currentPage() }} of {{ totalPages }}</span>
            <div class="flex gap-1">
              <button type="button" (click)="changePage(currentPage() - 1)"
                [disabled]="currentPage() === 1"
                class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:hover:bg-gray-800">
                Prev
              </button>
              <button type="button" (click)="changePage(currentPage() + 1)"
                [disabled]="currentPage() === totalPages"
                class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:hover:bg-gray-800">
                Next
              </button>
            </div>
          </div>
        }
      </div>

    </div>
  </div>
</div>
}
